<template>
  <div :class="[$style.notification, $style.activityMentioned]">
    <div :class="[$style.main, { [$style.open]: moreDetailsVisible }]">
      <a
        :href="formatUrl(notification.comment.url)"
        :class="$style.header"
        :target="linkTarget"
      >
        <img
          :src="photoUrl(notification.user.photoUrl)"
          :title="notification.user.name"
          alt=""
        />
        <i class="fa fa-comment"></i>
        <span>{{ notification.title }}</span>
      </a>
      <span :class="$style.toggleMoreDetails" @click="toggleMoreDetails"
        ><i class="fa fa-angle-left"></i
      ></span>
      <span :class="$style.timer">{{ timer }}</span>
      <div :class="$style.moreDetails">
        <div :class="$style.moreDetailsInner">
          <h5>{{ notification.comment.message }}</h5>
          <p :class="$style.moreDetailsBody">
            {{ notification.comment.context }}
            <br />at {{ notification.comment.time }}
            <a :href="formatUrl(notification.comment.url)" :target="linkTarget"
              ><i class="fa fa-play"></i> listen back</a
            >
          </p>
        </div>
      </div>
    </div>
    <a
      @click.prevent="readNotification(notification)"
      href="#"
      :class="$style.markAsRead"
      data-toggle="tooltip"
      data-placement="left"
      title="mark as read"
    >
      <font-awesome-icon :icon="faTrashAlt" />
    </a>
  </div>
</template>

<script>
import Notification from "./notification";

export default {
  mixins: [Notification],
  data() {
    return {
      moreDetailsVisible: true,
    };
  },
};
</script>

<style module lang="less" src="./notification.less"></style>



// WEBPACK FOOTER //
// activity-mentioned.vue?2146707f